import NotFound from './NotFound';

export default {
  path: '*',

  getComponents(location, cb) {
    cb(null, NotFound);
  },
};
